/* eslint-disable no-unused-vars */
import { TimeEntryErrorModel } from './timeEntryErrorModel'
import ResultDTO from '@/models/app/resultDTO'
import TimeEntryAPIErrorContext from '@/constants/booking/timeEntries/TimeEntryAPIErrorContext'
import ErrorResponseDTO from '@/models/error/errorResponseDTO'

export class TimeEntryMealBreakStartErrorModel extends TimeEntryErrorModel {
  /** @param {ResultDTO<ErrorResponseDTO>} errorResponse */
  constructor(errorResponse) {
    super(errorResponse, TimeEntryAPIErrorContext.mealBreakStart)

    /**
     * See {@link https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_wiki/wikis/anzuk%20Dev%20Team/366/Ready2Work-2.0?anchor=post-/api/v1.0/time-entries/meal-break-start Error Code Wiki}
     * @type {string[]}
     */
    this.errorCodesToRefresh = [
      'security_error',
      'auto_clocked_out',
      'booking_in_future',
      'booking_not_found',
      'reached_meal_break_limit',
      'already_started_meal_break',
      'already_clocked_out',
      'not_clocked_in',
    ]
  }

  /** @override */
  shouldTriggerTimeEntryStatusRefresh() {
    return this.errorCodesToRefresh.includes(this.errorCode)
  }
}
